<template>
    <v-app>
        <v-navigation-drawer v-model="drawer" app permanent>
            <!-- Logo Section -->
            <div class="logo-container">
                <h1 class="text-center">OSCE</h1>
            </div>

            <v-divider></v-divider>

            <!-- Menu Items -->
            <v-list dense nav>
                <v-list-item v-for="item in menuItems" :key="item.title" link :to="item.route">
                    <v-list-item-icon class="listItemIcon">
                        <v-icon class="listIcon">{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content class="listContent">
                        <v-list-item-title class="listTitle">{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- Logout Button at Bottom -->
                <v-list-item class="logout-btn" @click="logout">
                    <v-list-item-icon class="listItemIcon">
                        <v-icon class="listIcon">mdi-logout</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content class="listContent">
                        <v-list-item-title class="listTitle">登出</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>


        <v-main>
            <div class="d-flex justify-start align-start outliner">
                <router-view></router-view>
            </div>
        </v-main>
    </v-app>
</template>

<script>
import AuthService from '../services/auth.service'
import userService from '@/services/user.service'

export default {
    name: 'StudentView',
    data() {
        return {
            drawer: true,
            menuItems: [{
                title: '個人資料',
                icon: 'mdi-account',
                route: '/admin/profile'
            },
            {
                title: '學校管理',
                icon: 'mdi-school',
                route: '/admin/school'
            },
            {
                title: '教師管理',
                icon: 'mdi-school',
                route: '/admin/management'
            },
            {
                title: '回報管理',
                icon: 'mdi-message-reply',
                route: '/admin/reports'
            },
            ],
            dialog: false,
            showPassword: false,
            profile: {
                name: '',
                phone: '',
                email: '',
                account: '',
                password: '',
                school: {name: ''},
            },
            avatarPreview: null,
        }
    },
    methods: {
        init() {
            if (localStorage.getItem("authenticated")) {
                AuthService.verifyToken()
                    .then(() => {
                    })
                    .catch(() => {
                        localStorage.removeItem("authenticated")
                        this.$router.push('/')
                    })
            }else{
                this.$router.push('/')
            }
            userService.getUserInfo(localStorage.getItem('user_id')).then((res) => {
                this.profile = res.data
                if (res.data.userType !== undefined) {
                   if (res.data.userType == 1) {
                            this.$router.push("/school");
                      
                        } else if (res.data.userType == 2) {
                            this.$router.push("/teacher");
                    
                        } else if (res.data.userType == 3) {
                            this.$router.push("/student");
                     
                        }
                    }
                if(!this.profile.editedProfile){
                    this.dialog = true
                }
            })
        },
        logout() {
            // 處理登出邏輯
            AuthService.logout()
                .then(() => {
                    console.log("logout")
                    this.$router.push('/')
                })
                .catch(err => {
                    console.log(err)
                    alert(err.message)
                })
        },
        submitForm() {
            this.profile.editedProfile = true
            userService.updateUserInfo(localStorage.getItem('user_id'), this.profile).then(() => {
                this.init()
                this.dialog = false
            })
        },
        // onFileSelected(event) {
        //     const file = event.target.files[0];
        //     if (file) {
        //         // 預覽圖片
        //         const reader = new FileReader();
        //         reader.onload = (e) => {
        //             this.avatarPreview = e.target.result;
        //         };
        //         reader.readAsDataURL(file);

        //         // 這裡可以處理圖片上傳邏輯
        //         // 例如: this.uploadImage(file);
        //     }
        // },
        // // 可選：添加上傳圖片到服務器的方法
        // async uploadImage(file) {
        //     console.log(file)
        //     // 實現上傳邏輯
        //     // const formData = new FormData();
        //     // formData.append('avatar', file);
        //     // await axios.post('/api/upload-avatar', formData);
        // }    
        checkUserType() {
            if (localStorage.getItem('userType') != 0) {
                return window.location.reload()
            }else{
                return
            }
        },
    },
    mounted() {
        this.init()
        window.addEventListener("focus", this.checkUserType);
        document.addEventListener("visibilitychange", this.checkUserType);
    },
    beforeDestroy() {
        window.removeEventListener("focus", this.checkUserType);
        document.removeEventListener("visibilitychange", this.checkUserType);
    }
}
</script>

<style scoped>
.v-navigation-drawer {
    background-color: #f5f5f5;
    width: 300px !important;
}

.logo-container {
    padding: 30px;
    background-color: #000;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
}

.logo-container h1 {
    font-size: 24px;
}

.v-list {
    padding: 20px 10px 20px 10px;
}

.v-list-item {
    margin: 12px 0;
    height: 56px !important;
    border-radius: 8px;
}

.listItemIcon {
    align-self: center;
    margin-left: 12px;
}

.listIcon {
    font-size: 1.8rem !important;
}

.v-icon {
    font-size: 1.2rempx !important;
}

.listTitle {
    font-size: 1.2rem !important;
    line-height: 1.2rem !important;
    text-align: left;
    font-weight: 500;
}

.logout-btn {
    position: fixed;
    bottom: 0;
    padding: 20px 10px 20px 10px;
    border-top: 1px solid #e0e0e0;
    height: 64px !important;
    align-self: center;
    background-color: #f5f5f5;
}

.v-main {
    margin-left: 300px !important;
}

.v-list-item:hover {
    background-color: #e0e0e0;
}

.v-card {
    border-radius: 30px;
}

.v-card-title {
    display: block;
    padding: 0;
}

.avatar-upload {
    margin-left: 16px;
}

.avatar-preview {
    cursor: pointer;
    border: 2px dashed #e0e0e0;
    background-color: #f5f5f5;
    transition: all 0.3s;
}

.avatar-preview:hover {
    border-color: #000;
    opacity: 0.8;
}

.v-main {
    padding: 0 !important;
}

.outliner {
    border: 2px solid #000;
    padding: 30px;
    margin: 50px;
    margin-bottom: 150px;
    height: 90%;

}
</style>